<template>
  <ModalDialog
    ref="dialog"
    title="Edit Billing Address"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-address-card"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Address 1"><FormInputText placeholder="Address 1" v-model="billingData.billingAddress1" field="billingAddress1" /></FormRow>
      <FormRow label="Address 2"><FormInputText placeholder="Address 2" v-model="billingData.billingAddress2" field="billingAddress2" /></FormRow>
      <FormRow label="Suburb"><FormInputText placeholder="Suburb" v-model="billingData.billingSuburb" field="billingSuburb" /></FormRow>
      <FormRow label="State">
        <FormLocationStateSelect placeholder="State" countryCode="AU" v-model="billingData.billingState" field="billingState" />
      </FormRow>
      <FormRow label="Postcode"><FormInputText placeholder="Postcode" v-model="billingData.billingPostcode" field="billingPostcode" /></FormRow>
      <FormRow label="Country"><FormInputText placeholder="Country" v-model="billingData.billingCountry" field="billingCountry" /></FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "AccountBillingEditDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
  },
  data() {
    return {
      billingData: {
      },
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show(billingData) {
      // Reset form
      this.billingData = {}
      this.dialogForm = {}
      this.submitting = false

      if(billingData != null) {
        this.billingData = _.cloneDeep(billingData)
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.billingData)

      this.$apiService.adminService.updateAccountBilling(updateData)
      .then(() => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    }
  }
}
</script>